import { render, staticRenderFns } from "./TeamsList.vue?vue&type=template&id=19c5e534&scoped=true&"
import script from "./TeamsList.vue?vue&type=script&lang=js&"
export * from "./TeamsList.vue?vue&type=script&lang=js&"
import style0 from "./TeamsList.vue?vue&type=style&index=0&id=19c5e534&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c5e534",
  null
  
)

export default component.exports